import { Company } from "./company/Company";
import { ICompany } from "./company/ICompany";

export default class Bill {
    amount: number;
    amountPayable: number;
    broker?: Company;
    daysUntilDue: number;
    createdOn: string;
    description: string;
    dueDate: string;
    from: string;
    id: number;
    month: string;
    status: string; 
    referenceNumber: string;
    to: string;
    updatedOn: string;
    paid: boolean;
    paymentAdviceUrl: string;
    paymentAmount: number;
    paymentChannel: string;
    paymentDate: string;
    paymentReference: string;
    transactionId: string;
    discount: number;



    constructor(bill: IBill) {
        this.amount = bill.amount;
        this.amountPayable = bill.amountPayable;
        this.broker = bill.broker ? new Company(bill.broker) : undefined;
        this.createdOn = bill.createdOn;
        this.description = bill.description;
        this.dueDate = bill.dueDate;
        this.from = bill.from;
        this.id = bill.id;
        this.month = bill.month;
        this.status = bill.status;
        this.referenceNumber = bill.referenceNumber;
        this.to = bill.to;
        this.updatedOn = bill.updatedOn;
        this.daysUntilDue = bill.daysUntilDue;
        this.paid = bill.paid;
        this.createdOn = bill.createdOn;
        this.daysUntilDue = bill.daysUntilDue;
        this.paymentAdviceUrl = bill.paymentAdviceUrl;
        this.paymentAmount = bill.paymentAmount;
        this.paymentChannel = bill.paymentChannel;
        this.paymentDate = bill.paymentDate;
        this.paymentReference = bill.paymentReference;
        this.transactionId = bill.transactionId;
        this.discount = bill.amount - bill.amountPayable;
    }
}


interface IBill {
    amount: number;
    amountPayable: number;
    broker: ICompany;
    createdOn: string;
    description: string;
    dueDate: string;
    from: string;
    id: number;
    month: string;
    status: string;
    referenceNumber: string;
    to: string;
    updatedOn: string;
    daysUntilDue: number;
    paid: boolean;
    paymentAdviceUrl: string;
    paymentAmount: number;
    paymentChannel: string;
    paymentDate: string;
    paymentReference: string;
    transactionId: string;
}